import { Moment } from 'moment'

export default (
  value: Moment,
  siteTimezone = '',
  licenseeTimezone = '',
  keepDate = false,
) => {
  const timezone = siteTimezone || licenseeTimezone

  return timezone ? value.tz(timezone, keepDate) : value
}
